import { useAuth } from '../context/AuthContext';
import { Link } from 'react-router-dom';
import Cell from '../components/Cell'

export default function Home() {

  const currentUser = useAuth();

  return (
    <div>
      <div id='motus_title'>
        <Cell
          key={'1'}
          letter={'M'}
          status={'present'}
        />
        <Cell
          key={'2'}
          letter={'O'}
          status={'absent'}
        />
        <Cell
          key={'3'}
          letter={'M'}
          status={'present'}
        />
        <Cell
          key={'4'}
          letter={'O'}
          status={'absent'}
        />
        <Cell
          key={'5'}
          letter={'M'}
          status={'correct'}
        />
        <Cell
          key={'6'}
          letter={'O'}
          status={'correct'}
        />
        <Cell
          key={'7'}
          letter={'T'}
          status={'correct'}
        />
        <Cell
          key={'8'}
          letter={'U'}
          status={'correct'}
        />
        <Cell
          key={'9'}
          letter={'S'}
          status={'correct'}
        />
      </div>
      <div className='cleared'></div>

      {(currentUser !== null) ? (<p>Commencez par définir vos <Link to="/prefs">préférences</Link> de jeux.</p>):(<p><Link to="/authent/register">Créez un compte</Link> ou <Link to="/authent/login">connectez-vous</Link>.</p>)}

      <div style={{ justifyContent: "center", textAlign: "center" }}>
        <img src='/motus.png' alt='img motus' />
      </div>
    </div>
  );
}